
import { type Config as WinzigConfig } from "winzig";

winzigConfig: ({
	output: "../",
	appfiles: "appfiles",
	css: "./css/main.css",
}) satisfies WinzigConfig;

import { editorLayout$ } from "./main.tsx";
import { filesView$ } from "./files.tsx";
import { elements } from "./app.tsx";

// const Asdf = () => <div>asdf</div>;
// console.log((<Asdf />).textContent);

;
<html lang="en" className="no-transitions can-hover no-wco-animation"
	data:view={filesView$ ? "files" : "editor"} data:editorLayout={editorLayout$}>
	<head>
		<meta name="robots" content="all" />
		<meta name="author" content="Benjamin Aster" />
		<meta name="description" content="Pretty Awesome Math Markup – A user-friendly LaTeX alternative with a live editor" />
		<link rel="code-repository" href="https://github.com/BenjaminAster/PAMM" />
		<meta attr:property="og:image" content="https://benjaminaster.com/pamm/assets/screenshot-editor-desktop.png" />
		<meta name="twitter:card" content="summary_large_image" />

		<title>PAMM</title>
		<meta attr:property="og:title" content="PAMM" />

		<link rel="icon" href="./assets/icon.svg" type="image/svg+xml" sizes="any" />
		<link rel="icon" href="./assets/icon.png" type="image/png" sizes="512x512" />
		<link rel="manifest" href="./app.webmanifest" />
		<link rel="canonical" href="https://benjaminaster.com/pamm/" />
		<meta name="theme-color" content="black" id="theme-color-meta" />

		<link rel="preload" as="fetch" crossOrigin="anonymous" href="./assets/introduction.pamm" />
		<link rel="preload" as="font" crossOrigin="anonymous" href="./assets/newcomputermodern/regular.otf" />
		<link rel="preload" as="font" crossOrigin="anonymous" href="./assets/newcomputermodern/italic.otf" />
		<link rel="preload" as="font" crossOrigin="anonymous" href="./assets/newcomputermodern/bold.otf" />
		<link rel="preload" as="font" crossOrigin="anonymous" href="./assets/newcomputermodern/math.otf" />

		{/* <script type="module">
			if (!CSS.supports("(color: color-mix(in srgb, oklch(1% 1% 1deg), red))") && localStorage.getItem(`${location.pathname}:force`) !== "true") {
				location.assign("/update-your-browser/?source=" + location.pathname);
			}
		</script> */}

		<style id="paper-size-style">
			{`@page { size: A4 portrait; }`}
		</style>
	</head>

	<body>
		<noscript>Please enable JavaScript to view this site.</noscript>

		{/* <div>
			{JSON.stringify(await (await fetch(import.meta.resolve("../app.webmanifest"))).json(), null, "\t")}
		</div> */}

		{elements.header}

		{/* {filesView$ ? elements.files : elements.editor} */}
		{elements.main}

		{/* <div id="dummy"></div> */}
	</body>
</html>;
